export default __webpack_public_path__ + "static/media/bell2.84895f16.svg";